import { get } from 'lodash'

export const valToRem = (scale, value, fallback, { theme }) => {
  if (typeof value !== 'number' || value < 2) {
    return value
  }
  return get(theme, 'base.getLength', () => value)(value)
}

export const toCoreRem = (value, scale, props) => {
  const val = get(scale, value, value)

  return valToRem(scale, val, val, props)
}
